import { StyleSheet, View } from "react-native";

import { useCustomTheme } from "../hooks/useCustomTheme";
import { ThemedRichText } from "./ThemedRichText";
import { ThemedText } from "./ThemedText";

type ThemedHeadlineTextProps = {
  type?: string;
  headline: string;
  textContent?: string;
};

export const ThemedHeadlineText = ({
  type,
  headline,
  textContent,
}: ThemedHeadlineTextProps) => {
  const { colors, fonts } = useCustomTheme();
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View
          style={[styles.headlineContainer, { borderColor: colors.border }]}
        >
          {type && (
            <ThemedText style={fonts.regular} type="headline">
              {type.trim()}{" "}
            </ThemedText>
          )}
          <ThemedText style={fonts.heavy} type="headline">
            {headline}
          </ThemedText>
        </View>
        {textContent && (
          <ThemedRichText
            style={[styles.textContainer, { color: colors.text }]}
            textContent={textContent}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  content: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 32,
  },
  headlineContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    paddingBottom: 8,
    borderBottomWidth: 4,
  },
  textContainer: {
    width: "100%",
    maxWidth: 844,
    fontSize: 16,
    lineHeight: 24,
  },
});
